import React from "react";
import { Button, Container, Form, InputGroup } from "react-bootstrap";
import "./Subscription.css";

const Subscription = () => {
  return (
    <div className="section-container subscription">
      <Container>
      <div className="section-heading text-center">
        <span>Get Our Offers</span>
          <h2>Subscribe Today</h2>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum ea necessitatibus eveniet <br /> aut dolore cumque. Ex nam totam aspernatur obcaecati.</p>
        </div>
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-0">
            <div className="subscription-banner">
              <img
                src={require("../../../images/subscription/subscription1.png")}
                alt=""
                className="h-100 w-100"
              />
              <div className="subscriptionText">
                <div className="section-heading text-center">
                  <span className="fs-1">Shop Now</span>
                  <h2>Save Upto 10% Now</h2>
                  <Button variant="light rounded-0">Explore All</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-0">
            <div className="subscription-field-container">
              <div className="subscription-field">
                <div className="section-heading">
                    <h4 className="fw-light">Get Our Newsletter</h4>
                    <p>Lorem, ipsum dolor sit amet consecteturBlanditiis ad <br /> consectetur obcaecati, m, pariatur enim.</p>
                <InputGroup className="bg-transparent border-0">
                  <Form.Control
                    placeholder="Your Email Here"
                    aria-label="Your Email Here"
                    aria-describedby="basic-addon2"
                  />
                  <InputGroup.Text id="basic-addon2" className="bg-light">
                    Subscribe
                  </InputGroup.Text>
                </InputGroup>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Subscription;
